// src/hooks/useMobilePhonePin.ts
import { useEffect, useRef } from 'react';
import gsap from 'src/utils/gsapSetup';

type Params = {
  triggerClass: string;
  pinClass: string;
  scrollHeight: number;
  onProgress: (progress: number) => void;
  markers?: boolean;
};

export function useMobilePhonePin({
  triggerClass,
  pinClass,
  scrollHeight,
  onProgress,
  markers = false,
}: Params): void {
  const rafScheduled = useRef(false);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to(
        {},
        {
          scrollTrigger: {
            trigger: triggerClass,
            start: 'center-=32 center',
            end: `+=${scrollHeight - 700}`,
            pin: pinClass,
            scrub: 1,
            markers,
            invalidateOnRefresh: false,

            onUpdate(self) {
              if (rafScheduled.current) return;

              rafScheduled.current = true;
              requestAnimationFrame(() => {
                rafScheduled.current = false;
                onProgress(self.progress);
              });
            },
          },
        },
      );
    });

    return () => ctx.revert();
  }, [triggerClass, pinClass, scrollHeight, onProgress, markers]);
}
